/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Rental_Booking_Status_Auto_ReleasedInputs */

const en_rental_booking_status_auto_released = /** @type {(inputs: Rental_Booking_Status_Auto_ReleasedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Auto-Released`)
};

const es_rental_booking_status_auto_released = /** @type {(inputs: Rental_Booking_Status_Auto_ReleasedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Liberada Automáticamente`)
};

const fr_rental_booking_status_auto_released = /** @type {(inputs: Rental_Booking_Status_Auto_ReleasedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Auto-débloqué`)
};

const de_rental_booking_status_auto_released = /** @type {(inputs: Rental_Booking_Status_Auto_ReleasedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Automatisch freigegeben`)
};

const id_rental_booking_status_auto_released = /** @type {(inputs: Rental_Booking_Status_Auto_ReleasedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Dirilis Otomatis`)
};

/** @type {(inputs: Rental_Booking_Status_Auto_ReleasedInputs) => LocalizedString} */
const ja_rental_booking_status_auto_released = en_rental_booking_status_auto_released;

/** @type {(inputs: Rental_Booking_Status_Auto_ReleasedInputs) => LocalizedString} */
const zh_rental_booking_status_auto_released = en_rental_booking_status_auto_released;

/** @type {(inputs: Rental_Booking_Status_Auto_ReleasedInputs) => LocalizedString} */
const ar_rental_booking_status_auto_released = en_rental_booking_status_auto_released;

/** @type {(inputs: Rental_Booking_Status_Auto_ReleasedInputs) => LocalizedString} */
const it_rental_booking_status_auto_released = en_rental_booking_status_auto_released;

/** @type {(inputs: Rental_Booking_Status_Auto_ReleasedInputs) => LocalizedString} */
const ru_rental_booking_status_auto_released = en_rental_booking_status_auto_released;

/** @type {(inputs: Rental_Booking_Status_Auto_ReleasedInputs) => LocalizedString} */
const pt_rental_booking_status_auto_released = en_rental_booking_status_auto_released;

/** @type {(inputs: Rental_Booking_Status_Auto_ReleasedInputs) => LocalizedString} */
const ko_rental_booking_status_auto_released = en_rental_booking_status_auto_released;

/**
* | output |
* | --- |
* | "Auto-Released" |
*
* @param {Rental_Booking_Status_Auto_ReleasedInputs} inputs
* @param {{ locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }} options
* @returns {LocalizedString}
*/
export const rental_booking_status_auto_released = /** @type {((inputs?: Rental_Booking_Status_Auto_ReleasedInputs, options?: { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Rental_Booking_Status_Auto_ReleasedInputs, { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_rental_booking_status_auto_released(inputs)
	if (locale === "es") return es_rental_booking_status_auto_released(inputs)
	if (locale === "fr") return fr_rental_booking_status_auto_released(inputs)
	if (locale === "de") return de_rental_booking_status_auto_released(inputs)
	if (locale === "ja") return ja_rental_booking_status_auto_released(inputs)
	if (locale === "zh") return zh_rental_booking_status_auto_released(inputs)
	if (locale === "ar") return ar_rental_booking_status_auto_released(inputs)
	if (locale === "id") return id_rental_booking_status_auto_released(inputs)
	if (locale === "it") return it_rental_booking_status_auto_released(inputs)
	if (locale === "ru") return ru_rental_booking_status_auto_released(inputs)
	if (locale === "pt") return pt_rental_booking_status_auto_released(inputs)
	return ko_rental_booking_status_auto_released(inputs)
});